import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { JobForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class JobUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Job',
            key: shortid.generate(),
            name: '',
        }
    }

    componentDidMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/jobs/${id}`)

            this.setState({
                key: shortid.generate(),
                name: data.name,
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <JobForm
                    key={key}
                    path={`jobs/${id}`}
                    method="put"
                    name={name}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(JobUpdate)
